import { IStrings } from 'localization/IStrings';
import { QuickFilter } from '../DailyReceiptsList';

export const createQfRecord = (strings: IStrings): Record<QuickFilter, string> => {
	return {
		global: 'Globaal',
		location: 'Per locatie',
	};
};
